import { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import Button from '@/components/Button'
import View from '@/layout/View'

import useCheckout from '../Checkout/hooks/useCheckout'
import { ScannerFooter, ScannerLogo, ScannerVendor, ScannerWrapper } from './Scanner.styles'
import ScannerIndicator from './ScannerIndicator'
import withScanner from './withScanner'
import { useTheme } from '../../lib/hooks'

const Scanner = () => {
  const { t } = useTranslation()
  const { cart } = useCheckout()
  const navigate = useNavigate()
  const themes = useTheme()
  const [clickCount, setClickCount] = useState(0)
  const timeoutRef = useRef(null)

  const handleBergLogoClick = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    const newCount = clickCount + 1
    setClickCount(newCount)

    if (newCount === 5) {
      try {
        window.BtDevice.clearSettings()
      } catch (error) {
        console.error('[DEVICE] clearSettings error', error)
      }
      setClickCount(0)
    } else {
      timeoutRef.current = setTimeout(() => {
        setClickCount(0)
      }, 3000)
    }
  }

  return (
    <View theme="DARK" hideLogo={true}>
      <ScannerWrapper>
        <ScannerLogo>
          <img src={themes.assets.logo} alt="" />
        </ScannerLogo>
        <ScannerIndicator />
        <ScannerFooter>
          {cart.length > 0 && (
            <Button block onClick={() => navigate('/checkout')} badge={cart.length}>
              {t('goToCheckout')}
            </Button>
          )}
        </ScannerFooter>
        <ScannerVendor onClick={handleBergLogoClick} style={{ cursor: 'pointer' }}>
          <span>Powered by</span>
          <img src="/img/berg-pay.svg" alt="" />
        </ScannerVendor>
      </ScannerWrapper>
    </View>
  )
}

export default withScanner(Scanner)
